import { useEffect, useState } from "react";
import { Phone, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "../ui/sheet";
import { scrollToId } from "../../lib/smooth";
import { PHONE, TEL } from "../../lib/data";

const LINKS = [
  { id: "services", label: "Services" },
  { id: "labor", label: "Labor Guide" },
  { id: "rewards", label: "Rewards" },
  { id: "book", label: "Book" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), 50);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled ? "bg-[#07070b]/80 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8 lg:px-12">
        <button data-testid="header-logo" onClick={() => scrollToId("top")} className="shrink-0" aria-label="Bridgeway Auto home">
          <img src="/img/logo-sm.webp" alt="Bridgeway Auto Mobile Mechanic" className="h-11 w-auto sm:h-12" />
        </button>
        <nav className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => go(l.id)}
              className="group relative text-sm font-semibold uppercase tracking-[0.16em] text-zinc-300 transition-colors hover:text-white"
            >
              {l.label}
              <span className="absolute -bottom-1.5 left-0 h-[2px] w-full origin-left scale-x-0 bg-neon transition-transform duration-300 group-hover:scale-x-100" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href={TEL}
            data-testid="header-phone-link"
            className="flex items-center gap-2 rounded-full border border-white/15 px-3 py-2 text-sm font-semibold text-white transition-colors hover:border-[var(--mag)] sm:px-4"
          >
            <Phone className="h-4 w-4 text-[var(--mag)]" />
            <span className="hidden font-mono-x sm:inline">{PHONE}</span>
          </a>
          <button data-testid="nav-book-now-button" onClick={() => go("book")} className="btn-neon hidden rounded-full px-5 py-2.5 text-sm font-bold uppercase tracking-wider text-white sm:block">
            Book now
          </button>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button data-testid="mobile-menu-button" className="rounded-full border border-white/15 p-2.5 text-white md:hidden" aria-label="Open menu">
                <Menu className="h-5 w-5" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="border-white/10 bg-[#0b0b12] text-white">
              <SheetTitle className="sr-only">Menu</SheetTitle>
              <div className="mt-12 flex flex-col gap-6">
                {LINKS.map((l) => (
                  <button key={l.id} data-testid={`mobile-nav-${l.id}-link`} onClick={() => go(l.id)} className="font-race text-left text-5xl text-white">
                    {l.label}
                  </button>
                ))}
                <a href={TEL} data-testid="mobile-nav-call-link" className="btn-neon mt-6 rounded-full px-6 py-4 text-center font-bold uppercase tracking-wider">
                  Call {PHONE}
                </a>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
